export function useHostName() {
  const { subdomain, domain } = useSubdomain();
  const getHostName = () => {
    return subdomain ? `${subdomain}.comfortweather.com` : window.location.hostname;
  };
  return {
    hostName: getHostName(),
    getHostName,
    domain,
  };
}
